import type { PostStatus } from '~publish/components/graphqlEnums'

/** @see the `tab` entry of `channelSchedule.queryParams` in `~publish/legacy/routes` */
export type ScheduleTab = 'queue' | 'sent' | 'drafts' | 'approvals'

/**
 * Which schedule tab lists a post in the given status. Distinct from the legacy
 * `mapStatusToTab`, which returns pre-IA tab ids the current routes reject.
 */
export const mapPostStatusToTab = (status: PostStatus): ScheduleTab => {
  switch (status) {
    case 'draft':
      return 'drafts'
    case 'needs_approval':
      return 'approvals'
    case 'sent':
      return 'sent'
    // Mid-send and failed posts still sit in the queue.
    case 'scheduled':
    case 'sending':
    case 'error':
      return 'queue'
  }
}
